module.exports = __webpack_public_path__ + "img/legende100.71a3f696.jpg";